import { render, staticRenderFns } from "./MeetingList.vue?vue&type=template&id=2fbdf870"
import script from "./MeetingList.vue?vue&type=script&lang=js"
export * from "./MeetingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports